import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {IndexComponent} from './components/index/index.component';
import {LoginComponent} from './components/login/login.component';
import {SignupComponent} from './components/signup/signup.component';
import {HomeComponent} from './components/home/home.component';
import {ViewDetailComponent} from './components/view-detail/view-detail.component';
import {CreatesealComponent} from './components/createseal/createseal.component';
import {ExporterMaster} from './components/exporter_master/exporter_master';
import {ExporterListComponent} from './components/exporter-list/exporter-list.component';
import {ViewPoComponent} from './components/view-po/view-po.component';
import {CreatePoComponent} from './components/create-po/create-po.component';
import {ImportPurchaseOrderDetailComponent} from './components/import-purchase-order-detail/import-purchase-order-detail.component'
import {ImportPurchaseOrderListingComponent} from './components/import-purchase-order-listing/import-purchase-order-listing.component'
import {AppCustomPreloader} from './AppCustomPreloader'

const appRoutes: Routes = [
    {
        path: '',
        component: LoginComponent
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'signup',
        component: SignupComponent
    },
    /* {
         path: 'home',
         component: HomeComponent
     },
 
 
     {
         path: 'viewdetails',
         component: ViewDetailComponent
     },
     {
         path: 'createseal',
         component: CreatesealComponent
     },
     {
         path: 'exporter-list',
         component: ExporterListComponent
     },
     {
         path: 'view-purchase-order',
         component: ViewPoComponent
     },
     {
         path: 'create-purchase-order',
         component: CreatePoComponent
     },
     {
         path: 'exporter-master',
         component: ExporterMaster
     },
     {
         path: 'view-importpurchase-order',
         component: ImportPurchaseOrderListingComponent
     },
     {
         path: 'create-importpurchase-order',
         component: ImportPurchaseOrderDetailComponent
     },*/

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);

const appRoutes1: Routes = [
    {path: 'create-purchase-order', loadChildren: './components/lazyloader/CreatePo.module#CreatePoModule', data: {preload: false}},
    {path: 'createseal', loadChildren: './components/lazyloader/CreateSeal.module#CreatesealModule', data: {preload: false}},
    {path: 'exporter-list', loadChildren: './components/lazyloader/ExporterList.module#ExporterListModule', data: {preload: false}},
    {path: 'exporter-master', loadChildren: './components/lazyloader/ExporterMaster.module#ExporterMasterModule', data: {preload: false}},
    {path: 'create-importpurchase-order', loadChildren: './components/lazyloader/ImpPurchaseOrderDetail.module#ImportPurchaseOrderDetailModule', data: {preload: false}},
    {path: 'view-importpurchase-order', loadChildren: './components/lazyloader/ImpPurchaseOrderList.module#ImportPurchaseOrderListingModule', data: {preload: false}},
    {path: 'viewdetails', loadChildren: './components/lazyloader/ViewDetail.module#ViewDetailModule', data: {preload: false}},
    {path: 'view-purchase-order', loadChildren: './components/lazyloader/ViewPo.module#ViewPoModule', data: {preload: false}},
    {path: 'home', loadChildren: './components/lazyloader/Home.module#HomeModule', data: {preload: false}}   
];

export const routing1: ModuleWithProviders = RouterModule.forRoot(appRoutes1, {preloadingStrategy: AppCustomPreloader});



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/app.routing.ts